module.exports = __webpack_public_path__ + "static/img/ledportal-leapmotion.08fb749.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ledportal-leapmotion.gif
// module id = zblc
// module chunks = 0